'use client'

import React, {ChangeEvent,useState} from 'react';
import {Elements} from '@/types/theme'
import ListItemButton from "./ListItemButton";


type FileListProps = {
    currentElements: Elements[] | null | undefined;
    selectedElementId?: string | null;
};
export default function ThemeElementList(
    {
        currentElements,
        selectedElementId
    }: FileListProps) {


    const searchRef = React.useRef<HTMLInputElement>(null);


    const [searchQuery, setSearchQuery] = useState('');
    const handleOnSearch = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
    };

    const filteredElements = currentElements?.filter(element =>
        element.name.toLowerCase().includes(searchQuery.toLowerCase())
    );



    return (

            <div className="flex grow flex-col border-r border-gray-200 bg-white px-sm z-[16] relative">
                <div className={"sticky top-0 z-50 pt-sm bg-white"}>
                    <div className={`flex-grow max-h-[50px] h-[45px] border border-gray-300 rounded-md flex-row flex gap-md items-center px-md pr-[6px] transition-all cursor-text hover:border-primary-500 `}
                        onClick={() => searchRef.current?.focus()}
                    >
                        <span className={'font-icon-regular text-title-md text-gray-400'}></span>
                        <input
                            type="text"
                            className="text-gray-900 flex flex-grow focus:outline-0 text-title-md placeholder-gray-300 placeholder:text-text-md font-normal w-[90%]"
                            placeholder="Search by name..."
                            onChange={handleOnSearch}
                            ref={searchRef}
                        />
                    </div>
                </div>

                <ul role="list" className="flex flex-1 flex-col py-[30px]">
                    {filteredElements?.map((item) => (
                        <ListItemButton
                            item={item}
                            selectedElementId={selectedElementId}
                            key={item.id}
                        />
                    ))}
                </ul>
            </div>

    );
}


